export default "__VITE_ASSET__Cy6pmz57__"